import React, { useEffect, useState } from 'react';
import {
    Box,
    InputAdornment,
    Typography,
    TextField,
    Link,
    Backdrop,
    CircularProgress,
    Button
} from '@mui/material';
import { EmailOutlined as EmailIcon } from '@mui/icons-material';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { login, setLogin } from '../store/actions/auth';
import TextFieldPassword from '../components/TextFieldPassword';
import CusttomSnackbar from '../components/CusttomSnackbar';
import { BiLogIn } from 'react-icons/bi';

function Login({ addLogin, signIn, loading, error }) {
    const [openError, setOpenError] = useState(false);
    const history = useHistory();
    const [submitted, setSubmitted] = useState(false);

    const handleChangeSnackbar = () => {
        setOpenError(!openError);
    };

    useEffect(() => {
        if (submitted && !loading && !error) {
            history.push('/');
        }
    }, [error, loading, submitted, history]);

    return (
        <Box sx={{ maxWidth: '450px' }}>
            <Typography
                variant="h3"
                sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    mb: 2,
                    fontSize: { xs: '1.75rem', sm: '2.25rem' },
                }}
            >
                Sign In
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    color: 'text.secondary',
                    mb: 5,
                    fontSize: '1rem',
                    lineHeight: 1.6,
                }}
            >
                Enter your credentials to access your account
            </Typography>

            <Formik
                initialValues={{
                    email: "",
                    password: ""
                }}
                onSubmit={async (values) => {
                    addLogin(values);
                    handleChangeSnackbar();
                    await signIn();
                    setSubmitted(true);
                }}
            >
                {({ values, handleChange, handleSubmit }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <Box sx={{ mb: 4 }}>
                            <Typography
                                variant="body2"
                                sx={{ mb: 1, fontWeight: 500, color: 'text.primary' }}
                            >
                                Email Address
                            </Typography>
                            <TextField
                                id="email"
                                type="email"
                                placeholder="Enter your email"
                                value={values.email}
                                onChange={handleChange('email')}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <EmailIcon color="action" />
                                        </InputAdornment>
                                    ),
                                }}
                                fullWidth
                                variant="outlined"
                                size="medium"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Box>

                        <Box sx={{ mb: 3 }}>
                            <Typography
                                variant="body2"
                                sx={{ mb: 1, fontWeight: 500, color: 'text.primary' }}
                            >
                                Password
                            </Typography>
                            <TextFieldPassword variant="outlined" />
                        </Box>

                        <Box sx={{ mb: 4 }}>
                            <Link
                                component={RouterLink}
                                to="/login/forgot-password"
                                sx={{
                                    color: 'primary.main',
                                    textDecoration: 'none',
                                    fontSize: '0.95rem',
                                    '&:hover': {
                                        textDecoration: 'underline',
                                    },
                                }}
                            >
                                Forgot password?
                            </Link>
                        </Box>

                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            fullWidth
                            size="large"
                            startIcon={<BiLogIn size={20} />}
                            sx={{
                                py: 1.75,
                                borderRadius: 2,
                                textTransform: 'none',
                                fontSize: '1.1rem',
                                fontWeight: 600,
                            }}
                        >
                            Sign In
                        </Button>
                    </form>
                )}
            </Formik>

            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            {(!loading && error) && (
                <CusttomSnackbar
                    message="Username or Password is Incorrect"
                    type="error"
                    open={openError}
                    handleChange={handleChangeSnackbar}
                />
            )}
        </Box>
    );
}

const mapStateToProps = state => {
    const { auth } = state;
    return {
        loading: auth.loading,
        error: auth.error
    };
};

const mapDispatchToProps = dispatch => ({
    addLogin: login => dispatch(setLogin(login)),
    signIn: () => dispatch(login())
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
